/// <reference types="node" />

'use client';

import { LiveDrawProvider as LiveDrawProviderProd } from './LiveDrawProvider.prod';

/**
 * Swaps in the QA scrub provider under `next dev`.
 *
 * `require` rather than a static import so the dev module sits behind a branch the production build
 * can drop: `NODE_ENV` is inlined at build time, leaving the overlay, its scrub state and the slider
 * out of the client bundle entirely.
 */
function createLiveDrawProvider(): typeof LiveDrawProviderProd {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports -- dev-only module must not be a static import (production bundle).
    const { LiveDrawProviderDev } = require('./LiveDrawProvider.dev') as typeof import('./LiveDrawProvider.dev');
    return LiveDrawProviderDev;
  }

  return LiveDrawProviderProd;
}

const LiveDrawProvider = createLiveDrawProvider();

export { useLiveDraw, useOptionalLiveDraw } from './LiveDrawProvider.prod';
export type { LiveDrawContextValue, LiveDrawProviderProps } from './LiveDrawProvider.prod';
export { LiveDrawProvider };
